import { useEffect, useState } from 'react';

import { formatCSVDate } from '../../../utils/date_utils';

export const useCSVChartData = ({ chartType, title, data }) => {
  const [currentData, setCurrentData] = useState(data);
  const [csvData, setCsvData] = useState([[]]);

  useEffect(() => {
    if (
      ((!data) && chartType === 'simple')
      || ((!data.every(d => d?.data)) && chartType === 'multi')
      || (JSON.stringify(currentData) === JSON.stringify(data))
    ) {
      return;
    }

    const csvArray = chartType === 'simple'
      ? [['Timestamp', `${title} Data`], ...data.map(datum => [formatCSVDate(datum.x), datum.y])]
      : [
        ['Timestamp', `${data[0].label} Data`, `${data[1].label} Data`, `${data[2].label} Data`],
        ...data[0].data.map((datum, i) => [formatCSVDate(datum.x), datum.y, data[1]?.data[i]?.y, data[2]?.data[i]?.y]),
      ];

    setCurrentData(data);
    setCsvData(csvArray);
  }, [data, title, chartType, currentData]);
  
  return csvData;
}

export default useCSVChartData;
